module.exports = __webpack_public_path__ + "static/media/No_Claims_Icon.5ba5983c.svg";